import React from 'react';
import { FilterBar } from './FilterBar';
import { PickerOption } from './PropertyPicker';
import { SeverityGlyph, StatusIcon } from './StatusIcon';
import {
  SEVERITIES,
  STATUSES,
  VIOLATION_TYPES,
  ViolationFilters,
  ViolationStatus,
  statusLabel,
} from './violationMeta';

/** The violation fields on Linear's filter bar: status, severity, type. */
interface Props {
  filters: ViolationFilters;
  onChange: (next: ViolationFilters) => void;
  shown: number;
  total: number;
  /** Rendered at the far right, after search — the view switch. */
  trailing?: React.ReactNode;
  /**
   * The HOAs to offer (#618). Omit where the list is already scoped to
   * one HOA, and the HOA filter is not shown.
   */
  hoaOptions?: PickerOption[];
}

export const ViolationFilterBar: React.FC<Props> = ({
  filters,
  onChange,
  shown,
  total,
  trailing,
  hoaOptions,
}) => (
  <FilterBar
    fields={[
      {
        field: 'Status',
        options: STATUSES.map((s) => ({
          value: s.value,
          label: s.label,
          icon: <StatusIcon status={s.value} />,
        })),
        values: filters.statuses,
        onChange: (v) =>
          onChange({ ...filters, statuses: v as ViolationStatus[] }),
        label: statusLabel,
      },
      {
        field: 'Severity',
        options: SEVERITIES.map((s) => ({
          value: s,
          label: s,
          icon: <SeverityGlyph severity={s} />,
        })),
        values: filters.severities,
        onChange: (v) => onChange({ ...filters, severities: v }),
      },
      {
        field: 'Type',
        options: VIOLATION_TYPES.map((t) => ({ value: t, label: t })),
        values: filters.types,
        onChange: (v) => onChange({ ...filters, types: v }),
      },
      ...(hoaOptions
        ? [
            {
              field: 'HOA',
              options: hoaOptions,
              values: filters.hoas,
              onChange: (v: string[]) => onChange({ ...filters, hoas: v }),
            },
          ]
        : []),
    ]}
    search={filters.search}
    onSearch={(search) => onChange({ ...filters, search })}
    searchLabel="Search violations"
    onClearAll={() =>
      onChange({ ...filters, statuses: [], severities: [], types: [], hoas: [] })
    }
    shown={shown}
    total={total}
    trailing={trailing}
  />
);

export default ViolationFilterBar;
